/**
 * Texto "Mi …" por código de catálogo `tipos_entidad_cadencya` (alineado con el seed de Prisma).
 * @type {Record<string, string>}
 */
const MI_ENTIDAD_POR_CODIGO = {
  hermandad: 'Mi hermandad',
  cofradia: 'Mi cofradía',
  archicofradia: 'Mi archicofradía',
  asociacion_religiosa: 'Mi asociación religiosa',
  devocion_particular: 'Mi devoción',
  grupo_parroquial: 'Mi grupo parroquial',
  pro_hermandad: 'Mi pro-hermandad',
  asociacion_fieles: 'Mi asociación de fieles',
  congregacion: 'Mi congregación',
  agrupacion_hc: 'Mi agrupación',
  ayuntamiento: 'Mi ayuntamiento',
  asociacion_cultural: 'Mi asociación',
  fundacion: 'Mi fundación',
  otro: 'Mi entidad',
};

/**
 * Nombre por defecto cuando la entidad aún no tiene `nombre` guardado.
 * @param {{ codigo?: string; nombre?: string } | null | undefined} tipoEntidad Relación `tipoEntidad` del perfil o fila del catálogo.
 * @returns {string}
 */
export function getMiEntidadNombreDefecto(tipoEntidad) {
  if (!tipoEntidad) return 'Mi entidad';
  const codigo = tipoEntidad.codigo != null ? String(tipoEntidad.codigo).trim() : '';
  if (codigo && MI_ENTIDAD_POR_CODIGO[codigo]) {
    return MI_ENTIDAD_POR_CODIGO[codigo];
  }
  const nombre = tipoEntidad.nombre != null ? String(tipoEntidad.nombre).trim() : '';
  if (!nombre) return 'Mi entidad';
  return `Mi ${nombre.toLowerCase()}`;
}

/**
 * Nombre a mostrar en cabecera (AppLayout, etc.): perfil guardado o fallback por tipo.
 * @param {{ nombre?: string; tipoEntidad?: { codigo?: string; nombre?: string } } | null | undefined} profile
 * @param {'banda'|'cofradia'|'BANDA'|'COFRADIA'|string} userType
 */
export function getPerfilDisplayName(profile, userType) {
  const ut = String(userType || '').toLowerCase();
  const nombre = profile?.nombre != null ? String(profile.nombre).trim() : '';
  if (nombre) return nombre;
  if (ut === 'banda') return 'Mi Banda';
  return getMiEntidadNombreDefecto(profile?.tipoEntidad);
}
